var table_viewer_default = {
  "viewMode": "Qhw60",
  "editMode": "ATpR6",
  "container": "LGsPW",
  "cell": "hMWMj"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
